var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ConciergeChatManager } from './concierge-manager-base';
import config from '../../../config';
import { Logger } from '../../infra/observability/logger';
var SalesforceChatManager = /** @class */ (function (_super) {
    __extends(SalesforceChatManager, _super);
    function SalesforceChatManager() {
        var _this = _super.call(this, 'salesforce') || this;
        _this.waitForFullInit = function () {
            return new Promise(function (resolve, reject) {
                var maxNumberOfChecksLeft = 200;
                var initCheckInterval = setInterval(function () {
                    var _a;
                    maxNumberOfChecksLeft -= 1;
                    var hasEventHandler = !!((_a = window.embedded_svc) === null || _a === void 0 ? void 0 : _a.addEventHandler);
                    if (hasEventHandler) {
                        clearInterval(initCheckInterval);
                        resolve();
                    }
                    else if (maxNumberOfChecksLeft <= 0) {
                        Logger.error('Salesforce chat failed to initialize');
                        clearInterval(initCheckInterval);
                        reject();
                    }
                }, 50);
            });
        };
        _this.mount = function () {
            var _a;
            _this.mounted = true;
            var initESW = function (gslbBaseURL) {
                window.embedded_svc.menu.init('https://getsquire.my.salesforce.com', config.salesForceChat.url, gslbBaseURL, config.salesForceChat.key, 'Support');
            };
            var hasEmbeddedSvcObject = !!((_a = window.embedded_svc) === null || _a === void 0 ? void 0 : _a.menu);
            if (!hasEmbeddedSvcObject) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.onload = function () {
                    initESW(null);
                };
                script.src = 'https://getsquire.my.salesforce.com/embeddedservice/menu/fab.min.js';
                document.body.appendChild(script);
                // ipad legacy sets a custom user agent
                var isIpadLegacy = window.navigator.userAgent.toLowerCase().includes('ipad');
                var isMobileUserAgent = window.navigator.userAgent.includes('Mobi') || window.navigator.userAgent.includes('iOs');
                var isMobileOrIpadLegacy = isMobileUserAgent || isIpadLegacy;
                document.body.dataset.mobileclient = isMobileOrIpadLegacy.toString();
            }
            else {
                initESW('https://service.force.com');
            }
            var sfChatEl = document.getElementById('embedded-service');
            if (sfChatEl) {
                sfChatEl.style.display = 'flex';
            }
            return _this.waitForFullInit();
        };
        _this.open = function () {
            var _a, _b;
            var openSfChat = (_b = (_a = window.embedded_svc) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.openChannelMenu;
            if (openSfChat) {
                openSfChat();
            }
        };
        _this.close = function () {
            var _a, _b;
            var closeSfChat = (_b = (_a = window.embedded_svc) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.closeChannelMenu;
            if (closeSfChat) {
                closeSfChat();
            }
        };
        _this.unmount = function () {
            var _a;
            _this.mounted = false;
            _this.close();
            var sfChatEl = document.getElementById('embedded-service');
            if (sfChatEl) {
                sfChatEl.style.display = 'none';
            }
            try {
                (_a = window.embedded_svc) === null || _a === void 0 ? void 0 : _a.liveAgentAPI.endChat();
            }
            catch (e) {
                // do nothing
            }
        };
        return _this;
    }
    return SalesforceChatManager;
}(ConciergeChatManager));
export { SalesforceChatManager };
